export default {
  navigate: {
    id: 'pagination_navigate',
    defaultMessage: 'Navigate to page {page}',
  },
}
